// extracted by mini-css-extract-plugin
export default {"imageIcon":"FloatingButton_imageIcon__84eTW","shake":"FloatingButton_shake__ue8mR"};